import admin from "./Admin";
import user from "./User";
import searchResult from "./SearchResult";
import searchResponse from "./SearchResponse";
import gcpSearchResponse from "./GcpSearchResponse";
import gtinSearchResponse from "./GtinSearchResponse";
import organization from "./Organization";
import DailyCheckerReport from "./DailyCheckerReport";

const userDefinedEntities = {
  admin,
  user,
  searchResult,
  searchResponse,
  gtinSearchResponse,
  gcpSearchResponse,
  organization,
  DailyCheckerReport,
};

const groups = [
  {
    name: { en: "group1", ar: "الجروب" },
    type: "normal",
    entities: [],
  },
  {
    name: "ungrouped",
    entities: [admin, user, searchResult, organization],
  },
  {
    name: "Sheets",
    entities: [DailyCheckerReport],
  },
];
export { userDefinedEntities, groups };
